module.exports = __webpack_public_path__ + "static/media/simon-canuso-kiley.49d057cd.md";